export default "__VITE_ASSET__qHk9bAiW__"